import GenericSelectableTable from "../../components/selectableTable";

import {  NXEditPen } from "../../icons";



import { Link } from "react-router-dom";



function PageTable({ orders }: any) {
  

// Define columns with render functions for custom content
const columns = [
  { header: "id", key: "node.dbId" },
    { header: "title", key: "node.title" },
    { header: "Slug", key: "node.slug" },
    { header: "Actions", key: "actions", render: (item: any) => (
        <div className="flex gap-2">
         <Link to={`../pages/editor/?pageId=${item.node.dbId}`} className="p-1">
            <NXEditPen />
        </Link>
        </div>
    )}
];

const printableColumn = [
  { header: "id", key: "node.dbId" },
  { header: "title", key: "node.title" },
  { header: "Slug", key: "node.slug" },
]



return (
  <div className="relative overflow-x-auto">
    <GenericSelectableTable  printableColumn={printableColumn} columns={columns} data={orders} />


  </div>
);
}

export default PageTable;
